<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-button type="primary" @click="$router.push($route.path + '/add')"
        >新增APP版本记录</a-button
      >

      <Padding />

      <a-table
        bordered
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        rowKey='id'
      >
        <a-table-column title="APP名称" data-index="name" align='center'></a-table-column>
        <a-table-column title="版本" data-index="version" align='center'></a-table-column>
        <a-table-column title="Android安装包" data-index="androidUrl">
          <template slot-scope="androidUrl">
            <a-space>
              <span>{{ $getFileName( androidUrl) }}</span>
              <a-icon type="copy" @click="$copy(androidUrl)" style="color: #999" />
            </a-space>
          </template>
        </a-table-column>



                <a-table-column title="ios链接" data-index="iosUrl">
          <template slot-scope="iosUrl">
            <a-space>
              <span>{{ iosUrl }}</span>
              <a-icon type="copy" @click="$copy(iosUrl)" style="color: #999" />
            </a-space>
          </template>
        </a-table-column>


                <a-table-column title="Windows安装包" data-index="windowsUrl">
          <template slot-scope="windowsUrl">
            <a-space>
              <span>{{ $getFileName( windowsUrl) }}</span>
              <a-icon type="copy" @click="$copy(windowsUrl)" style="color: #999" />
            </a-space>
          </template>
        </a-table-column>

                <a-table-column title="macOS安装包" data-index="macOsUrl">
          <template slot-scope="macOsUrl">
            <a-space>
              <span>{{ $getFileName( macOsUrl) }}</span>
              <a-icon type="copy" @click="$copy(macOsUrl)" style="color: #999" />
            </a-space>
          </template>
        </a-table-column>

                     <a-table-column title="harmonyOS安装包" data-index="harmonyOsUrl">
          <template slot-scope="harmonyOsUrl">
            <a-space>
              <span>{{ $getFileName( harmonyOsUrl) }}</span>
              <a-icon type="copy" v-if="harmonyOsUrl" @click="$copy(harmonyOsUrl)" style="color: #999" />
            </a-space>
          </template>
        </a-table-column>

        <a-table-column
          title="更新说明"
          data-index="remark"
        ></a-table-column>

        <a-table-column
          title="更新时间"
          data-index="updateDate"
          align="center"
        ></a-table-column>

        <a-table-column title="操作" align="center">
          <template slot-scope="text">
            <a-space>

                        <a href="#" @click.prevent="edit(text)"
              >编辑</a
            >
            <a href="#" style="color: #f00" @click.prevent="deleteText(text)"
              >删除</a
            >
            </a-space>

          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { fetchList, remove } from "@/api/setting/ai-version";
export default {
  data() {
    return {
      current: 1,
      pageSize: 10,
      loading: false,
      list: [],
      total: 0,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      this.loading = true;
      fetchList({
        pageNum: this.current,
        pageSize: this.pageSize,
      })
        .then((res) => {
          if (res && Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    edit(text) {
       window.localStorage.setItem('editingAIApp', JSON.stringify(text))
      this.$router.push(this.$route.path + '/edit')
    },

    deleteText(text) {
      const that = this;

      this.$confirm({
        title: "确认要删除这个版本吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>